import { render, staticRenderFns } from "./Mention.vue?vue&type=template&id=45145d0d&scoped=true"
import script from "./Mention.vue?vue&type=script&lang=js"
export * from "./Mention.vue?vue&type=script&lang=js"
import style0 from "./Mention.vue?vue&type=style&index=0&id=45145d0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45145d0d",
  null
  
)

export default component.exports